module.exports = __webpack_public_path__ + "static/media/care_in_hospital_important.57f57d41.svg";